import { useMemo } from 'react';

export function useServiceInstance<T>(ServiceClass: new () => T): T {
  return useMemo(() => new ServiceClass(), [ServiceClass]);
}
